export default __webpack_public_path__ + "static/media/euro-symbol.ecb95f22.svg";